<template>
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">Get Browser Information</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <label class="form-label">Enter browser string from log</label>
        <textarea 
          v-model="browserstring"
          class="form-control"
          rows="3"
        />
      </div>
      <div v-show="device_type !== ''">
        <div class="mb-3">
          <input v-model="device_type" type="text" class="form-control" readonly />
        </div>
        <div class="mb-3">
          <input v-model="platform" type="text" class="form-control" readonly />
        </div>
        <div class="mb-3">
          <input v-model="browser" type="text" class="form-control" readonly />
        </div>      
      </div>
      <button
        @click.prevent="getinformation"
        class="btn btn-primary"
      >
        Get information
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { config } from '../../config';
const api_token = config.api_token;

export default {
  name: 'GetBrowser',
  data() {
    return {
      browserstring: '',
      device_type: '',
      platform: '',
      browser: '',
    }
  },
  methods: {
    getinformation() {
      const data = {
        b: this.browserstring,
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:' + api_token;
      return new Promise((resolve) => {
        axios.post(
          'http://api.eventerex.com/gdq/gdq_getbrowser.php',
          JSON.stringify(data), {
            headers: {
              "Accept": "application/json",
              "Content-type": "application/json",
            }
          }
        )
        .then((resp) => {
          this.device_type = resp.data.device_type;
          this.platform = resp.data.platform;
          this.browser = resp.data.browser + ' ' + resp.data.version;
          resolve(resp);
        })
      });           
    },
  }  
}
</script>
